// Messages for operator/settings/FeatureFlags (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.feature_flags.head': 'Feature flags — Operator',
  'operator.feature_flags.title': 'Feature flags',
  'operator.feature_flags.desc':
    'Turn optional modules on or off globally. Core modules are always on.',
  'operator.feature_flags.on': 'On',
  'operator.feature_flags.off': 'Off',
  'operator.feature_flags.enabled_toast': '{label} enabled',
  'operator.feature_flags.disabled_toast': '{label} disabled',
  'operator.feature_flags.group.sales': 'Sales & quoting',
  'operator.feature_flags.group.engagement': 'Customer engagement',
  'operator.feature_flags.group.data': 'Data & operations',
  'operator.feature_flags.group.integrations': 'Integrations & API',
  'operator.feature_flags.group.advanced': 'Advanced & access',
}

export const zhTW = {
  'operator.feature_flags.head': '功能旗標 — 操作員',
  'operator.feature_flags.title': '功能旗標',
  'operator.feature_flags.desc': '全域開啟或關閉選用模組。核心模組永遠開啟。',
  'operator.feature_flags.on': '開啟',
  'operator.feature_flags.off': '關閉',
  'operator.feature_flags.enabled_toast': '已啟用 {label}',
  'operator.feature_flags.disabled_toast': '已停用 {label}',
  'operator.feature_flags.group.sales': '銷售與報價',
  'operator.feature_flags.group.engagement': '客戶互動',
  'operator.feature_flags.group.data': '資料與作業',
  'operator.feature_flags.group.integrations': '整合與 API',
  'operator.feature_flags.group.advanced': '進階與存取',
}
